
export const FundProfileError = () => {
  return (
    <div className="p-4 md:p-6">
      <p>Fund not found</p>
    </div>
  );
};

